export const chartCommonOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: 'rgb(33, 43, 54)',
      titleColor: 'rgb(255, 255, 255)',
      bodyColor: 'rgb(255, 255, 255)',
      padding: 12,
      displayColors: false,
      boxPadding: 4,
      callbacks: {
        title: () => null,
        label: (context) => `${context.parsed.y.toLocaleString()}`
      }
    }
  },
  interaction: {
    intersect: false,
    mode: 'index'
  },
  scales: {
    x: {
      grid: { 
        display: false,
        drawBorder: false
      },
      ticks: { 
        color: 'rgb(145, 158, 171)',
        font: {
          size: 11,
          family: "'Plus Jakarta Sans', sans-serif"
        },
        padding: 8
      },
      border: { display: false }
    },
    y: {
      grid: { 
        color: 'rgba(145, 158, 171, 0.12)',
        drawBorder: false,
        lineWidth: 1
      },
      ticks: { 
        color: 'rgb(145, 158, 171)',
        callback: (value) => value.toLocaleString(),
        font: {
          size: 11,
          family: "'Plus Jakarta Sans', sans-serif"
        },
        padding: 8,
        stepSize: 5000,
        maxTicksLimit: 6
      },
      border: { display: false }
    }
  }
};

export const sparklineOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { 
    legend: { display: false },
    tooltip: { enabled: false }
  },
  scales: {
    x: { display: false },
    y: { 
      display: false,
      min: 0
    }
  },
  elements: {
    line: {
      borderWidth: 2,
      tension: 0.5
    },
    point: {
      radius: 0
    }
  }
}; 